import { render, staticRenderFns } from "./FormularioAclaracion.vue?vue&type=template&id=dfd78d2a"
import script from "./FormularioAclaracion.vue?vue&type=script&lang=js"
export * from "./FormularioAclaracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports